/**
 *
 * Mobylogix
 * Author: Mobylogix
 * Email: info@mobylogix.com
 * Website: mobylogix.com
 * Version: 1.0
 * Date: Tue Sep 28 2021
 * Category: Pages
 * Title: Header
 *
 */

import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { useHistory } from "react-router-dom";

// styles
import './header.css';

const Header = ({ drawerShow, setDrawerShow }) => {

  const [isLogo, setIsLogo] = useState(false);

  const history = useHistory();

  useEffect(() => {
    window.onscroll = () => {
      let mainHeader = document.getElementsByClassName("main-header");
      mainHeader = mainHeader[0] ? mainHeader[0] : null;
      if (!mainHeader) return;

      if (window.pageYOffset > 50) {
        mainHeader.classList.add("fixed");
        setIsLogo(true);
      } else {
        mainHeader.classList.remove("fixed");
        setIsLogo(false);
      };
    }
  });

  useEffect(() => {
    // NOTE: Logic for adding class in header when opening menu
    const headerMenus = document.querySelectorAll('.menu-dropdown-holder');
    for (let i = 0; i < headerMenus.length; i++) {
      headerMenus[i].addEventListener('mouseenter', e => {
        const header = document.querySelector(".main-header");
        header && header.classList.add("on-hover");
        setIsLogo(true);
      });
  
      headerMenus[i].addEventListener('mouseleave', e => {
        const header = document.querySelector(".main-header");
        header && header.classList.remove("on-hover");
        if (header && header.classList.contains('fixed')) {
          header && header.classList.add("fixed");
          setIsLogo(true);
        }
        setIsLogo(false);
      });
    }
  }, []);

  const clickHandler = (path) => {
    const header = document.querySelector(".main-header");
    header && header.classList.remove("on-hover");

    const mainMenu = document.querySelector(".main-menu .menu-dropdown");
    mainMenu && mainMenu.classList.add("d-none");

    setTimeout(() => {
      mainMenu && mainMenu.classList.remove("d-none");
    }, 500);
    history.push(path);
  }

  return (
    <header className="main-header">
      <div className="dropdown-wrap">
        <Container>
          <div className="nav-holder">
            <div className="logo">
              <a href="/" rel="nooppener noreferrer">
                <img src={isLogo ? 'images/logo.png' : 'images/mobylogix-white.png'} alt="Mobylogix" width="180px" height="70px" />
              </a>
            </div>
            <ul className="main-menu">
              <ServicesMenu history={ history } clickHandler={clickHandler} />
              <li>
                <a rel="nooppener noreferrer" className="uppercase" onClick={() => history.push("/work")}>Work</a>
              </li>
              <li>
                <a rel="nooppener noreferrer" className="uppercase" onClick={() => history.push("/about")}>About</a>
              </li>
              {/* <li>
                <a rel="nooppener noreferrer" className="uppercase" onClick={() => window.location.href = "/careers" }>Careers</a>
              </li> */}
              <li>
                <a rel="nooppener noreferrer" className="uppercase" onClick={() => window.location.href = '/contact'}>Contact</a>
              </li>
            </ul>
            <ul className="main-menu second-menu">
              <li>
                {/* <a href="tel:+13235225593" rel="nooppener noreferrer" className="uppercase">
                  <svg version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 53.942 53.942" className="link-icon">
                    <path d="M53.364,40.908c-2.008-3.796-8.981-7.912-9.288-8.092c-0.896-0.51-1.831-0.78-2.706-0.78c-1.301,0-2.366,0.596-3.011,1.68  c-1.02,1.22-2.285,2.646-2.592,2.867c-2.376,1.612-4.236,1.429-6.294-0.629L17.987,24.467c-2.045-2.045-2.233-3.928-0.632-6.291  c0.224-0.309,1.65-1.575,2.87-2.596c0.778-0.463,1.312-1.151,1.546-1.995c0.311-1.123,0.082-2.444-0.652-3.731  c-0.173-0.296-4.291-7.27-8.085-9.277c-0.708-0.375-1.506-0.573-2.306-0.573c-1.318,0-2.558,0.514-3.49,1.445L4.7,3.986  c-4.014,4.013-5.467,8.562-4.321,13.52c0.956,4.132,3.742,8.529,8.282,13.068l14.705,14.705c5.746,5.746,11.224,8.66,16.282,8.66  c0,0,0,0,0.001,0c3.72,0,7.188-1.581,10.305-4.698l2.537-2.537C54.033,45.163,54.383,42.833,53.364,40.908z"/>
                    <g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g>
                  </svg>
                  <span className="link-text">323 (522) 5593</span>
                </a> */}
              </li>
              <li>
                <a href="/contact" rel="nooppener noreferrer" className="btn btn-primary">
                  <span className="link-text">
                    Estimate Project
                  </span>
                  <svg className="link-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" version="1.1" style={{ shapeRendering: 'geometricPrecision', textRendering: 'geometricPrecision', imageRendering: 'optimizeQuality', fillRule: 'evenodd', clipRule: 'evenodd' }}
                    viewBox="0 0 89.02 88.99">
                    <g id="Layer_x0020_1">
                      <metadata id="CorelCorpID_0Corel-Layer"/>
                      <path className="fil0" d="M16.7 60.95c3.75,-0.87 5.93,-0.87 9.68,0l-2.37 2.82c-0.52,0.52 -0.68,0.84 -1.16,1.35l-1.3 1.39c-0.47,-0.32 -0.73,-0.81 -1.21,-1.3l-3.63 -4.26zm48.22 -16.12c-0.52,-0.52 -0.37,-1.01 -0.36,-1.98l0 -6.99 -2.87 0 -0.19 8.78c-0.02,0.04 -0.13,0.15 -0.17,0.19 -1.41,0.08 -2.77,1.66 -3.35,2.73 -1.54,2.86 -0.24,6.74 3.01,7.99 2.66,1.02 3.92,-0.05 5.18,-0.34l3.18 3.27 2.06 -2.16 -3.23 -3.13c0.18,-0.91 1.37,-2.85 0.26,-5.28 -0.55,-1.22 -2.02,-3 -3.53,-3.09zm-4.66 5.55c-0.14,-0.91 0.71,-2.86 2.72,-3 1.59,-0.11 2.87,1.26 2.97,2.68 0.24,3.45 -5.09,4.21 -5.69,0.32zm-40.16 -24.2c-0.21,-1.06 0.53,-3.1 1.56,-4.17 5.47,-5.69 13.28,2.5 8.35,7.63 -1.03,1.07 -2.08,1.7 -3.87,1.88 -0.6,0.06 -1.9,-0.19 -2.39,-0.38 -1.21,-0.48 -2.39,-1.62 -3,-2.74l-0.65 -2.21zm-2.87 -1.08l0 1.43c0,3.84 4.05,7.89 7.89,7.89l1.43 0c3.84,0 7.89,-4.05 7.89,-7.89l0 -1.43c0,-3.84 -4.05,-7.89 -7.89,-7.89 -2.67,0 -4.81,0.4 -6.86,2.46 -1.24,1.24 -2.46,3.56 -2.46,5.43zm-5.74 -0.27l0.16 -0.46c0.13,-0.83 -0.03,-0.79 0.35,-2.15 1.18,-4.21 3.83,-7.38 7.73,-9.3 1.87,-0.92 3.09,-1.06 5.43,-1.39 1.6,-0.22 4.49,0.46 5.64,0.9 1.6,0.61 3.1,1.5 4.3,2.51 1.15,0.98 2.34,2.42 3.09,3.72l1.46 3.56c0.12,0.4 0.21,0.95 0.33,1.38 0,2.61 0.35,3.64 -0.58,6.67 -0.46,1.49 -1.7,3.77 -2.69,4.84l-2.54 2.33c-0.03,0.02 -0.07,0.05 -0.1,0.07 -1.3,0.89 -2.68,1.53 -4.24,2.02 -1.4,0.43 -1.18,0.17 -2.6,-0.76 -3.97,-2.59 -8.55,-0.91 -9.36,-1.19 -1.61,-0.55 -4.34,-4.15 -5.15,-6.17 -0.78,-1.94 -1.23,-3.8 -1.23,-6.58zm31.37 -1.24c0,-2.15 -1.14,-4.56 -1.91,-6.08 -0.44,-0.88 -1.07,-1.76 -1.65,-2.48 -1.91,-2.35 -4.27,-4.11 -7.12,-5.25 -5.48,-2.19 -12.84,-1.31 -17.33,2.73 -0.23,0.21 -0.3,0.32 -0.55,0.53 -1.03,0.86 -1.63,1.55 -2.48,2.71 -1.66,2.26 -3.2,5.97 -3.2,9.08 0,5.33 0.94,7.99 3.76,11.75 0.81,1.08 1.83,1.67 2.51,2.69 -0.66,0.91 -1.88,1.08 -3.59,4.3l-3.81 -3.72c0.21,-0.67 1.29,-2.22 1.66,-2.91 -0.42,-0.79 -0.89,-1.46 -1.28,-2.31 -0.5,-1.09 -1.16,-2.69 -1.44,-3.94 -0.3,-1.32 0.18,-0.85 -2.16,-1.43 -0.51,-0.13 -1.01,-0.21 -1.4,-0.4l0 -5.28c0,-0.94 -0.15,-0.82 0.66,-1.06 2.26,-0.67 2.42,-0.07 2.77,-1 0.35,-0.91 0.43,-1.95 1.44,-4.3 0.35,-0.82 0.98,-1.72 1.41,-2.53 -0.49,-0.93 -1.46,-2.22 -1.61,-2.87l4.26 -4.35c0.67,0.19 1.96,1.15 2.91,1.66 2.08,-1.1 3.65,-2.13 6.24,-2.72 0.87,-0.2 0.87,0.05 1.11,-0.68 0.1,-0.31 0.24,-1.18 0.32,-1.47 0.13,-0.51 0.21,-1.01 0.4,-1.4l6.09 0c0.34,0.7 0.51,2.25 0.71,2.87 0.24,0.74 0.24,0.49 1.11,0.68 2.89,0.65 4.04,1.55 6.24,2.72 0.72,-0.38 2.19,-1.43 2.87,-1.61l4.35 4.26c-0.19,0.68 -0.47,0.94 -0.8,1.44 -0.32,0.5 -0.62,1 -0.86,1.52 0.97,1.51 1.7,2.98 2.31,4.81 0.18,0.54 0.27,0.77 0.41,1.38 0.2,0.87 -0.05,0.87 0.68,1.11 0.31,0.1 1.18,0.24 1.47,0.32 0.51,0.13 1.01,0.21 1.4,0.4l0 5.92c-4.24,2.84 -6.77,6.1 -9,10.52 -0.99,1.96 -1.07,2.94 -1.58,4 -0.48,-0.25 -0.78,-0.47 -1.25,-0.72 -1.07,0.56 -3.35,2.04 -4.66,2.15l-1.25 -2.51c2.93,-0.24 7.06,-3.82 8.89,-6.35 1.05,-1.45 1.96,-3.26 2.51,-5.2 0.34,-1.18 1.15,-5.54 0.43,-7zm3.23 -9.19c0.48,-0.68 1.62,-2.37 1.79,-3.1l-7.48 -7.57c-1.83,0.5 -2.9,2.3 -3.91,1.78 -1.17,-0.6 -3.07,-1.62 -4.38,-1.73 0,-1.45 -0.69,-2.42 -0.72,-3.76l-11.11 0c-0.03,1.35 -0.72,2.32 -0.72,3.76 -0.88,0.07 -2.41,0.77 -3.3,1.18 -1.79,0.81 -1,1.09 -2.93,-0.14 -0.58,-0.37 -1.32,-0.88 -2.01,-1.04l-7.53 7.53c0.4,1.71 2.23,2.82 1.75,3.88l-1.01 2.05c-0.27,0.65 -0.68,1.54 -0.74,2.31 -1.45,0 -2.42,0.69 -3.76,0.72l0 3.33 0 7.79c1.35,0.03 2.32,0.72 3.76,0.72 0.13,1.51 1.29,3.34 1.75,4.36 0.21,0.47 0.2,0.42 -0.06,0.89l-0.81 1.34c-0.02,0.03 -0.05,0.07 -0.08,0.11 -0.4,0.57 -0.64,0.81 -0.81,1.54 0.81,1.21 5.76,5.35 6.27,6.45 0.02,0.03 0.03,0.05 0.03,0.1l-0.03 3.25c0.43,2.13 0.72,3.14 1.73,4.77 0.45,0.73 0.86,1.2 1.45,1.78 0.3,0.3 0.5,0.53 0.81,0.81 0.58,0.52 0.67,0.27 0.85,0.94 -1.5,0.13 -4.4,1.92 -5.67,2.76 -1.1,0.73 -3.86,3.11 -4.37,4.16 -0.18,0.12 -0.04,-0.02 -0.33,0.29l-2.18 3.37c-1.84,3.52 -2.33,6.5 -2.33,10.61 0,3.48 -0.62,7.42 3.87,9.01 1.6,0.56 10.26,0.28 12.62,0.28 1.09,0 2.21,0.1 3.03,-0.19 0.27,-0.1 0.84,-0.37 1.09,-0.53 0.41,-0.26 0.49,-0.44 0.9,-0.71 1.67,1.12 1.43,1.45 4.12,1.44l11.12 0c2.05,0.01 3.11,-0.34 4.25,-1.31 2.57,-2.16 2.01,-4.67 2.02,-9.09 0.01,-2.51 -0.45,-4.97 -1.28,-7.15 -0.18,-0.47 -0.62,-1.54 -0.87,-1.96 -1.83,-3.89 -4.94,-7 -8.59,-9.19 -0.79,-0.48 -3.05,-1.69 -4.13,-1.78 0.32,-1.18 4.84,-2.96 4.84,-9.54l0 -1.4c1.09,-0.09 2.44,-0.9 3.35,-1.34 1.76,-0.85 0.95,1.45 0.95,2.73 0,9.13 2.36,14.4 8.65,20.61 5.26,5.21 14.62,7.57 22.26,6.03 7.78,-1.56 13.59,-6.32 17.1,-12.12 3.02,-4.98 4.49,-11.79 3.25,-17.88 -0.22,-1.05 -0.43,-1.91 -0.7,-2.88 -0.16,-0.57 -0.62,-2.24 -1.08,-2.62 -0.75,-3.82 -7.02,-10.41 -10.99,-12.38l-2.27 -1.13c-6.69,-3.22 -15.68,-2.74 -21.87,0.54l0 -6.81c-1.35,-0.03 -2.32,-0.72 -3.76,-0.72 -0.07,-0.86 -1,-3.07 -1.48,-3.91 -0.39,-0.69 -0.46,-0.47 -0.31,-1.23zm-32.99 35.75c-0.02,-0.87 -0.45,-1.73 0.24,-3.83 0.49,-1.49 0.74,-1.87 1.55,-2.93 2.23,-2.94 6.1,-3.85 9.76,-2.58 0.93,0.33 2.11,1.13 2.75,1.73 1.39,1.28 2.73,3.76 2.73,6.37 -0.19,2.45 -1.07,4.32 -2.37,5.73 -2.94,3.19 -7.9,3.6 -11.62,0.76 -1.25,-0.95 -2.89,-3.24 -3.04,-5.25zm-4.3 15.22c1.19,-1.25 3.3,-2.52 4.84,-3.33l3.9 4.53c0.45,0.47 0.52,0.56 0.92,1.06 0.36,0.45 0.65,0.63 1.03,1.12 0.44,0.56 0.59,0.65 1.01,1.14 0.47,0.53 0.42,0.71 1.03,1.12 0.36,-0.24 1.66,-1.74 1.97,-2.15l3.92 -4.51c0.59,-0.74 1.48,-1.53 2,-2.3 0.77,0.41 1.62,0.9 2.37,1.4 2.08,1.39 4.68,3.81 5.7,5.99 1.88,2.4 2.7,7.35 2.69,10.72 -0.01,2.43 0.23,4.35 -1.28,5.36 -1.31,0.88 -4.15,0.56 -6.25,0.56 -2.21,0 -4.43,0 -6.64,0.01 -3.22,0.01 -3.38,-2.18 -2.62,-3.35 0.88,-1.35 3.51,-0.96 5.67,-0.96 2.27,0 4.54,0 6.81,0l0 -2.87 -2.87 0 0 -5.74 -2.87 0 0 5.74c-1.68,0 -3.35,-0 -5.03,-0.01 -2.12,-0.01 -2.45,0.68 -3.58,1.44 -1.13,-0.76 -1.46,-1.45 -3.58,-1.44 -1.68,0 -3.35,0.01 -5.03,0.01l0 -5.74 -2.87 0 0 5.74 -2.87 0 0 2.87c1.44,0 10.21,-0.16 11.19,0.1 0.97,0.25 1.77,1.1 1.67,2.19 -0.2,2.41 -2.88,2.01 -5.52,2.01 -2.57,0 -5.14,-0.01 -7.71,0 -2.67,0.01 -3.93,-0.96 -3.95,-3.58 -0.05,-6.79 0.67,-12.28 5.92,-17.11zm37.11 -16.46c-0.94,-0.47 -4.22,-0.14 -5.56,-0.14 0,-2.72 0.95,-5.81 1.79,-7.71 1.79,-3.99 2.35,-3.81 3.76,-5.92l3.99 3.9 2.15 -2.06 -4.03 -3.94c2.38,-1.66 1.78,-1.86 5.84,-3.75 1.87,-0.87 5.18,-1.85 7.83,-1.85l0 5.56 2.87 0 0 -5.56c4.23,0 9.01,2.02 12.24,4.43 0.55,0.41 0.91,0.81 1.38,1.13l-3.9 3.99 1.97 2.07 4.04 -3.95c1.56,2.22 1.31,1.29 3.02,4.41l0.49 0.65c0.05,0.81 2.09,4.2 2.09,8.6l-5.56 0 0 2.87 5.56 0c0,3.9 -1.59,7.76 -3.48,10.86l-2.08 2.76 -4.08 -3.99 -2.05 2.15 4.03 3.94c-0.56,0.39 -0.73,0.68 -1.33,1.09 -1.93,1.3 -2.03,1.51 -4.51,2.66 -1.91,0.89 -5.12,1.85 -7.83,1.85l0 -5.56 -2.87 0 0 5.56c-4.36,0 -8.93,-2 -12.22,-4.46 -0.47,-0.35 -0.98,-0.81 -1.41,-1.1l3.99 -4.08 -2.15 -2.05 -3.94 4.03c-1.65,-2.35 -2.12,-2.23 -3.75,-5.82 -0.89,-1.96 -1.85,-5.11 -1.85,-7.85l5.56 0 0 -2.73z"/>
                    </g>
                  </svg>
                </a>
              </li>
              <li>
                <a className="drawer-icon" onClick={() => setDrawerShow(!drawerShow)}>
                  <svg height="24" width="24" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24">
                    <line x1="3" x2="21" y1="12" y2="12"/><line x1="3" x2="21" y1="6" y2="6"/><line x1="3" x2="21" y1="18" y2="18"/>
                  </svg>
                </a>
              </li>
            </ul>
          </div>
        </Container>
      </div>
    </header>
  );
}

Header.propTypes = {};

export default Header;

const ServicesMenu = ({history, clickHandler}) => (
  <li className="menu-dropdown-holder">
    <a href="#" rel="nooppener noreferrer" className="uppercase">Services</a>
    <div className="menu-dropdown">
      <div className="menu-dropdown-wrap">
        <Container>
          <Row>
            <Col xs="12" md="6" lg="3">
              <div className="dropdown-heading">
                <h3 className="title">Resources</h3>
                <p className="description">We are building industry leading digital tools to create the most distinctive market ruling digital products.</p>
              </div>
            </Col>
            <Col xs="12" md="6" lg="3">
              <div className="dropdown-col-wrap">
                <h3 className="main-title">Servies</h3>
                <ul className="dropdown-col-list">
                  <li>
                    <a onClick={() => clickHandler('/mobile-app-development')} rel="nooppener noreferrer">
                      <h4 className="title">Mobile Apps Development</h4>
                      <p>iOS, Android and Wearable Apps</p>
                    </a>
                  </li>
                  <li>
                    <a onClick={() => clickHandler('/saas-web-development')} rel="nooppener noreferrer">
                      <h4 className="title">SaaS/Web Development</h4>
                      <p>Robust web development</p>
                    </a>
                  </li>
                  <li>
                    <a onClick={() => clickHandler("/ecommerce-development")} rel="nooppener noreferrer">
                      <h4 className="title">Ecommerce Development</h4>
                      <p>Ecommerce Development</p>
                    </a>
                  </li>
                  {/* <li>
                    <a onClick={() => clickHandler("/internet-of-things")} rel="nooppener noreferrer">
                      <h4 className="title">Internet of Things</h4>
                      <p>iOS, Android and Wearable Apps</p>
                    </a>
                  </li> */}
                  <li>
                    <a onClick={() => clickHandler("/machine-learing")} rel="nooppener noreferrer">
                      <h4 className="title">AI/Machine Learning</h4>
                      <p>AI and Machine Learning</p>
                    </a>
                  </li>
                  <li>
                    <a onClick={() => clickHandler("/blockchain-development")} rel="nooppener noreferrer">
                      <h4 className="title">Blockchain Development</h4>
                      <p>Blockchain DApp Development</p>
                    </a>
                  </li>
                </ul>
              </div>
            </Col>
            <Col xs="12" md="6" lg="3">
              <div className="dropdown-col-wrap">
                <h3 className="main-title">&nbsp;</h3>
                <ul className="dropdown-col-list">
                  <li>
                    <a onClick={() => clickHandler("/cloud-services")} rel="nooppener noreferrer">
                      <h4 className="title">Cloud Services</h4>
                      <p>Cloud Services</p>
                    </a>
                  </li>
                  <li>
                    <a onClick={() => clickHandler("/virtual-reality")} rel="nooppener noreferrer">
                      <h4 className="title">Virtual Reality (VR)</h4>
                      <p>Modern AR apps</p>
                    </a>
                  </li>
                  <li>
                    <a onClick={() => clickHandler("/mvp-development")} rel="nooppener noreferrer">
                      <h4 className="title">MVP Development</h4>
                      <p>MVP for Startups</p>
                    </a>
                  </li>
                  <li>
                    <a onClick={() => clickHandler("/custom-enterprise-software-development")} rel="nooppener noreferrer">
                      <h4 className="title">Custom Enterprise Software Development</h4>
                      <p>Custom Enterprise Software Development</p>
                    </a>
                  </li>
                </ul>
              </div>
            </Col>
            <Col xs="12" md="6" lg="3">
              <div className="dropdown-col-wrap">
                <h3 className="main-title">How we Work</h3>
                <ul className="dropdown-col-list">
                  <li>
                    <a rel="nooppener noreferrer">
                      <h4 className="title">Discovery</h4>
                      <p>Exploring project requirements</p>
                    </a>
                  </li>
                  <li>
                    <a rel="nooppener noreferrer">
                      <h4 className="title">Design</h4>
                      <p>Intuitive and engaging designs</p>
                    </a>
                  </li>
                  <li>
                    <a rel="nooppener noreferrer">
                      <h4 className="title">Development</h4>
                      <p>Agile development processes</p>
                    </a>
                  </li>
                  <li>
                    <a rel="nooppener noreferrer">
                      <h4 className="title">Testing</h4>
                      <p>Incremental testing and QA</p>
                    </a>
                  </li>
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  </li>
);